"use client";
import React, { useState, useEffect } from "react";

const CandidateCard = ({ candidate, onReject }) => {
  const {
    full_name,
    name,
    email,
    experience,
    job_title,
    Resume_Score,
    screening_overall_score,
    coding_overall_score,
    personality_overall_score,
    behavioral_overall_score,
    job_id,
    isShortlisted,
    isRejected
  } = candidate;

  const [shortlisted, setShortlisted] = useState(isShortlisted || false);

  const handleToggleShortlist = async (candidateId, currentStatus, job_id) => {
    const newStatus = !currentStatus;
    try {
      const response = await fetch(`https://aievaluator.in/api/update-shortlist?jobId=${job_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ candidateId, isShortlisted: newStatus }),
      });

      if (response.ok) {
        setShortlisted(newStatus);
      }
    } catch (error) {
      console.error("Error updating shortlist status:", error);
    }
  };

  const handleToggleReject = async (candidateId, job_id) => {
    try {
      const response = await fetch(`https://aievaluator.in/api/update-reject?jobId=${job_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ candidateId }),
      });

      if (response.ok) {
        onReject(candidateId);
      }
    } catch (error) {
      console.error("Error updating reject status:", error);
    }
  };

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-white border border-indigo-100 rounded-xl p-5 flex flex-col gap-3 hover:-translate-y-1 transition-transform shadow-sm">
      <img
        loading="lazy"
        src={"user.jpg"}
        alt="Avatar"
        className="w-20 h-20 rounded-full object-cover border-2 border-indigo-200"
      />
      <div className="min-h-[80px] text-sm w-full">
        <div className="flex items-center gap-3 mb-1">
          <span className="font-medium text-slate-800">Name:</span>
          <span className="text-slate-500">{full_name || name || "N/A"}</span>
        </div>
        <div className="flex items-center gap-3 mb-1">
          <span className="font-medium text-slate-800">Email:</span>
          <span className="text-slate-500">{email}</span>
        </div>
        {experience && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Experience:</span>
            <span className="text-slate-500">{experience} years</span>
          </div>
        )}
        {job_title && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Applied To:</span>
            <span className="text-slate-500">{job_title}</span>
          </div>
        )}
        {Resume_Score && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Resume Score:</span>
            <span className="text-slate-500">{Resume_Score}%</span>
          </div>
        )}
        {screening_overall_score && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Screening Score:</span>
            <span className="text-slate-500">{screening_overall_score}%</span>
          </div>
        )}
        {personality_overall_score && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Personality Score:</span>
            <span className="text-slate-500">{personality_overall_score}%</span>
          </div>
        )}
        {behavioral_overall_score && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Behavioral Score:</span>
            <span className="text-slate-500">{behavioral_overall_score}%</span>
          </div>
        )}
        {coding_overall_score && (
          <div className="flex items-center gap-3 mb-1">
            <span className="font-medium text-slate-800">Coding Score:</span>
            <span className="text-slate-500">{coding_overall_score}%</span>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 mt-2">
        <button
          className={`px-4 py-2 text-white text-sm font-medium rounded-lg transition-colors ${shortlisted ? 'bg-indigo-900 hover:bg-indigo-800' : 'bg-[#4c00ff] hover:bg-indigo-700'}`}
          onClick={() => handleToggleShortlist(email, shortlisted, job_id)}
        >
          {shortlisted ? "Shortlisted" : "Shortlist"}
        </button>
        <button
          className={`px-4 py-2 text-white text-sm font-medium rounded-lg transition-colors ${isRejected ? 'bg-red-800 hover:bg-red-900' : 'bg-red-600 hover:bg-red-700'}`}
          onClick={() => handleToggleReject(email, job_id)}
        >
          {isRejected ? "Delete" : "Reject"}
        </button>
      </div>
    </div>
  );
};

const CandidateFollowup = ({ maxHeight }) => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    job_title: 'All Jobs',
    page: 1,
    per_page: 10
  });
  const [totalCount, setTotalCount] = useState(0);
  const [availableJobs, setAvailableJobs] = useState([]);

  const handleReject = (candidateId) => {
    setCandidates(prevCandidates =>
      prevCandidates.filter(candidate => candidate.email !== candidateId)
    );
  };

  const fetchAvailableJobs = async () => {
    try {
      const response = await fetch('https://aievaluator.in/api/employer-jobs');
      if (response.ok) {
        const jobs = await response.json();
        setAvailableJobs(jobs);
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  const fetchCandidates = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();

      if (filters.job_title && filters.job_title !== 'All Jobs') {
        params.append('job_title', filters.job_title);
      }
      params.append('page', filters.page);
      params.append('per_page', filters.per_page);

      const response = await fetch(`https://aievaluator.in/api/candidatelist_without_jobID?${params}`);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setCandidates(data.candidates || []);
      setTotalCount(data.total || 0);
    } catch (error) {
      console.error("Error fetching candidates:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableJobs();
  }, []);

  useEffect(() => {
    fetchCandidates();
  }, [filters]);

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value,
      page: 1 // Reset to first page when filters change
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({
      ...prev,
      page: newPage
    }));
  };

  if (loading) {
    return <div className="p-5 text-center text-base text-slate-500">Loading candidates...</div>;
  }

  if (error) {
    return <div className="p-5 text-center text-base text-red-500">Error: {error}</div>;
  }

  return (
    <div className="comp-recent-jobs-container">
      <div className="w-full mb-4">
        <h2 className="text-lg font-semibold text-slate-800 mb-4">Candidate Details</h2>
        <div className="border-t border-slate-200 mb-4"></div>

        {/* Filters */}
        <div className="flex gap-5 my-4 flex-wrap">
          <div className="flex flex-col gap-1.5">
            <label htmlFor="job-filter" className="font-semibold text-sm text-slate-700">Filter by Job:</label>
            <select
              id="job-filter"
              value={filters.job_title}
              onChange={(e) => handleFilterChange('job_title', e.target.value)}
              className="text-sm border border-slate-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-200"
            >
              <option value="All Jobs">All Jobs</option>
              {availableJobs.map(job => (
                <option key={job.job_id} value={job.job_title}>
                  {job.job_title}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col gap-1.5">
            <label htmlFor="per-page" className="font-semibold text-sm text-slate-700">Candidates per page:</label>
            <select
              id="per-page"
              value={filters.per_page}
              onChange={(e) => handleFilterChange('per_page', parseInt(e.target.value))}
              className="text-sm border border-slate-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-200"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      <div className="comp-jobs-list-container" style={{ maxHeight: `${maxHeight - 150}px` }}>
        <div className="comp-jobs-list">
          {candidates.length === 0 ? (
            <div className="py-10 text-center text-slate-400 italic">No candidates found</div>
          ) : (
            candidates.map((candidate, index) => (
              <CandidateCard
                key={`${candidate.email}-${candidate.job_id}`}
                candidate={candidate}
                onReject={handleReject}
              />
            ))
          )}
        </div>
      </div>

      {/* Pagination */}
      {totalCount > filters.per_page && (
        <div className="flex items-center justify-center gap-4 mt-5 py-4">
          <button
            disabled={filters.page === 1}
            onClick={() => handlePageChange(filters.page - 1)}
            className="px-4 py-2 bg-[#4c00ff] text-white text-sm rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed border-none cursor-pointer"
          >
            Previous
          </button>

          <span className="font-semibold text-slate-700">
            Page {filters.page} of {Math.ceil(totalCount / filters.per_page)}
          </span>

          <button
            disabled={filters.page >= Math.ceil(totalCount / filters.per_page)}
            onClick={() => handlePageChange(filters.page + 1)}
            className="px-4 py-2 bg-[#4c00ff] text-white text-sm rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed border-none cursor-pointer"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default CandidateFollowup;
